import dynamic from 'next/dynamic';
const ButtonScrollTo = dynamic(() => import('./ScrollToWrapper'));
export default ButtonScrollTo;
